import {Component, Input, OnInit} from '@angular/core';
import {FileDetails} from '../../../model/file-details.model';
import {UserService} from '../../../service/user.service';
import {FileService} from '../../../service/file.service';
import {User} from '../../../model/user.model';

@Component({
    selector: 'app-display-picture',
    templateUrl: './display-picture.component.html',
    styleUrls: ['./display-picture.component.css']
})
export class DisplayPictureComponent implements OnInit {
    @Input()
    userId: string;
    @Input()
    fileId: string;
    displayPicture = new FileDetails(null, null, '../../../../assets/images/default-user-dp.svg');

    constructor(private userService: UserService, private fileService: FileService) {
    }

    async ngOnInit(): Promise<void> {
        if (this.userId) {
            const user = await this.userService.getProfileDetails(this.userId);

            if (this.displayPictureUploadedFor(user)) {
                this.displayPicture = await this.fileService.getFileData(user.identity.proofs[0].fileIds[0]);
            }
        } else if (this.fileId) {
            this.displayPicture = await this.fileService.getFileData(this.fileId);
        }
    }

    private displayPictureUploadedFor(user: User) {
        return user.identity && user.identity.proofs && user.identity.proofs[0] && user.identity.proofs[0].fileIds;
    }
}
